import { mapGetters } from "vuex";
import { DISPLAY, OAPI_API_TYPE, ROUTE_NAMES } from "@/utils";
import { listVideoInputDevices } from "../adapters/codeScannerAdapter";

const ScanAndGoMixin = {
  data() {
    return {
      availableRoutes: [ROUTE_NAMES.MENU, ROUTE_NAMES.FAVORITES, ROUTE_NAMES.ORDER_AGAIN, ROUTE_NAMES.OFFERINGS],
      hasCamera: false
    };
  },
  computed: {
    ...mapGetters({
      activeVendor: "vendor/getActiveVendor",
      APIType: "venueSettings/APIType",
      categoryNames: "vendor/getVendorMenu"
    })
  },
  methods: {
    async hasInputDevices() {
      const devices = await listVideoInputDevices();
      return !!devices.length;
    },
    showScanIcon() {
      return (
        this.activeVendor?.scanToAddToCart &&
        this.hasCamera &&
        this.APIType === OAPI_API_TYPE &&
        this.availableRoutes.some((route) => this.$route.name === route)
      );
    },
    showScanMessage() {
      return this.showScanIcon() && !!this.categoryNames.length;
    },
    showMustScanMessage() {
      return this.activeVendor?.scanToAddToCart && this.hasCamera && this.APIType === OAPI_API_TYPE && !this.categoryNames.length;
    },
    showRequireCameraMessage() {
      return this.activeVendor?.scanToAddToCart && !this.hasCamera && !this.categoryNames.length;
    },
    openScanModal() {
      this.$modal.show(
        "ScanModal",
        {},
        window.innerWidth >= DISPLAY.minDesktopWidth
          ? {
              name: "ScanModal",
              height: "100%",
              width: "75%",
              adaptive: true,
              scrollable: false
            }
          : {
              name: "ScanModal",
              height: "100%",
              width: "100%",
              adaptive: true,
              scrollable: false
            }
      );
    }
  },
  created() {
    this.hasInputDevices().then((res) => {
      this.hasCamera = res;
    });
  }
};

export default ScanAndGoMixin;
